import { TS_ItemInterface } from './TS_ItemInterface';
import { TS_ItemType } from './TS_ItemType';
import { TS_Offer } from './TS_Offer';

export class TS_OfferEvent extends TS_Offer implements TS_ItemInterface {
    type = TS_ItemType.OFFER_EVENT;
}